module.exports = ".evidencia-seleccionada{\r\n\r\n    background-color: #85cdee !important;\r\n}\r\n\r\n.misma-evidencia{\r\n    background-color: beige;\r\n}\r\n\r\n.checkbox-size{\r\n    height: 20px;\r\n    width: 20px;\r\n}\r\n\r\n.padding{\r\n    padding:10px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/evidenciasequitativas/evidenciasequitativas.component.css
// module id = ./src/app/evidenciasequitativas/evidenciasequitativas.component.css
// module chunks = main